module.exports = __webpack_public_path__ + "media/components/maps/incidents/pins/Travel-a64ceaf78908441ff9381832486168d0.png";